import { render } from "./TheHero.vue?vue&type=template&id=37dfbb02"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"
script.render = render

export default script